import Button from "components/Button"
import { useEffect } from "react"
import { useKey } from "utils/hooks"

const ActionsFormItem = (props: {
  adding: boolean
  onChange: Function
  flush?: boolean
  loading?: boolean
}) => {
  const keyDownHandler = (e: any) => {
    if (e.code === "KeyA" && e.shiftKey) props.onChange("add")
    console.log('props.onChange("add") : Actions form')
  }

  useKey(keyDownHandler, !props.adding)

  if (props.adding)
    return (
      <Button
        loading={props.loading}
        className="w-max text-[13px]"
        text="Add Record"
        onClick={() => props.onChange("add")}
      />
    )

  return (
    <div
      className="flex-r-box"
      style={{ paddingLeft: props.flush ? 0 : 24, alignItems: "center" }}
    >
      <i
        className="ri-checkbox-circle-fill ri-lg"
        style={{ marginRight: 12, cursor: "pointer" }}
        onClick={() => props.onChange("accept")}
      />
      <i
        className="ri-close-circle-line ri-lg"
        style={{ marginRight: 12, cursor: "pointer" }}
        onClick={() => props.onChange("cancel")}
      />
    </div>
  )
}

export default ActionsFormItem
